import React from 'react';
import PropTypes from 'prop-types';
import { Label, Checkmark } from './styles';

const Radio = ({ children, ...props }) => (
  <Label>
    {children}
    <input type="radio" {...props} />
    <Checkmark />
  </Label>
);

Radio.defaultProps = {
  onChange: () => {},
};

Radio.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default Radio;
